module.exports = __webpack_public_path__ + "media/tips/01_logo-62ea5274.svg";